import React from 'react'
import HomeBanner from './home/HomeBanner'
import Opportunities from './home/Opportunities'
import MissionVision from './home/MissionVision'
import HomeAbout from './home/HomeAbout'
import HomeReviews from './home/HomeReviews'
import HomeGallery from './home/HomeGallery'
import HomeBlog from './home/HomeBlog'
import OurTeam from './home/OurTeam'
import HomeTopResult from './home/HomeTopResult'
import NewsAdvertisement from './home/NewsAdvertisement'
import HomeAbout1 from './home/HomeAbout1'
import HomeFaq from './home/HomeFaq'

const Home = () => {
  return (
    <>
    
      <HomeBanner />
      <HomeAbout />
      <Opportunities />
      <MissionVision />
      <NewsAdvertisement />
      <HomeReviews />
      <HomeGallery />
      <HomeAbout1 />
      <HomeFaq />
      
      {/* <HomeTopResult />
      <OurTeam /> */}
      {/* <HomeBlog /> */}



    </>
  )
}

export default Home